import { DEFAULT_PRECISION } from '@funnels/constants';

export default function formatToPrecision(amount: number, precision: number = DEFAULT_PRECISION) {
  const validAmount = !isNaN(Number(amount)) ? Number(amount) : 0;
  return Number(validAmount.toFixed(precision));
}
